import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    TabContent, TabPane, Nav, NavItem, NavLink,
    Button
} from "reactstrap"
import classnames from 'classnames'
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";
import moment from "moment"

import apiResponse from '../../../../../services/apiResponse';

import DetailBloc from '../Blocs/DetailBloc'

class Kompt extends Component {
    
    detailBloc = new DetailBloc()
    
    constructor(props) {
        super(props)
        this.state = {
            detail:{},
            acData : {},
            acDetail : [{}],
            stankomData : [{}],
            totgap:0,
            levelComps: [
                {
                    name: "",
                    level : 1
                },
            ],
            activeTab: '1',
        }
    }
    toggle = tab => {
        if(this.state.activeTab !== tab) this.setState({activeTab:tab});
    }
    loadAcData = async () => {
        const query = {
            uuid: this.props.uuid
        }
        // console.log(query)
        await this.detailBloc.fetchAcData(query)
    }
    loadAcDetail = async () => {
        const query = {
            uuid: this.props.uuid
        }
        // console.log(query)
        await this.detailBloc.fetchAcDetail(query)
    }
    loadStankom = async () => {
        const query = {
            posuuid: this.props.posuuid
        }
        // console.log(query)
        await this.detailBloc.fetchStankom(query)
    }
    componentDidMount() {
        this.loadAcData()
        this.loadAcDetail()
        this.loadStankom()
        this.detailBloc.acDataChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        // console.log(response)
                        this.setState({
                            acData : response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.detailBloc.acDetailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        // console.log('acDetail')
                        // console.log(response)
                        this.setState({
                            acDetail : response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.detailBloc.stankomChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        // console.log('stankom')
                        // console.log(response)
                        this.setState({
                            stankomData : response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

       
    }
    reformatLevel = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["name"] = data.level_name;
          newObj["level"] = data.level_no;
      
          return newObj;
        });
    }

    totalGap = 0;

    render() {
        return (
            <Fragment>
                {/* <h4>{this.props.uuid}</h4> */}

                <table className="table table-bordered">
                    <thead>
                        <tr style={{background:"#808e95"}}>
                            <th className="text-white text-center">No.</th>
                            <th className="text-white">Deskripsi Kompetensi</th>
                            <th colSpan="5" className="text-center text-white">Tingkat Kemahiran</th>
                            <th className="text-white text-center">SKJ</th>
                            <th className="text-white text-center">GAP</th>
                        </tr>
                    </thead>
                    <tbody style={{background:"#e2f1f8"}}>
                        {
                            this.state.stankomData.map((data,index)=>{    
                                // let totgap = 0;
                                let color = '';
                                if (typeof this.state.acDetail[index] === 'undefined'){
                                    // console.log(this.state.stankomData)
                                    return "";
                                }

                                if(this.state.acDetail[index].level_no > data.stancom_competence_level){
                                    color = 'bg-info';
                                }else if(this.state.acDetail[index].level_no < data.stancom_competence_level){
                                    color = 'bg-danger';
                                }
                                else if(this.state.acDetail[index].level_no == data.stancom_competence_level){
                                    color = 'bg-success';
                                }else{
                                    color = '';
                                }
                                this.totalGap += (this.state.acDetail[index].level_no - data.stancom_competence_level);
                                // this.totalGap = totgap;
                                // console.log("+ ",this.totalGap)
                                //this.setState({totgap:statetotgap });
                                return(
                                    <tr>
                                        <td className="text-center">{(index+1)}</td>
                                        <td>{data.competence_name}</td>
                                        {/* <td className={`text-center ${(this.state.acDetail[index].level_no==0)?'text-white '+color:''}`}>0</td> */}
                                        <td className={`text-center ${(this.state.acDetail[index].level_no==1)?'text-white '+color:''}`}>1</td>
                                        <td className={`text-center ${(this.state.acDetail[index].level_no==2)?'text-white '+color:''}`}>2</td>
                                        <td className={`text-center ${(this.state.acDetail[index].level_no==3)?'text-white '+color:''}`}>3</td>
                                        <td className={`text-center ${(this.state.acDetail[index].level_no==4)?'text-white '+color:''}`}>4</td>
                                        <td className={`text-center ${(this.state.acDetail[index].level_no==5)?'text-white '+color:''}`}>5</td>
                                        <td className="text-center">{data.stancom_competence_level}</td>
                                        <td className="text-center">{(this.state.acDetail[index].level_no - data.stancom_competence_level)}</td>
                                    </tr>
                                )  
                            })
                        }
                    </tbody>
                    <tfoot>
                        <tr style={{background:"#808e95"}}>
                            <th colSpan="2" className="text-white">GAP Kompetensi</th>
                            <th colSpan="6" className="text-white text-right" align="right" style={{textAlign:"right"}}>Total</th>
                            <th className="text-white text-center">{ (this.state.acDetail?.reduce(
                                (a, v) => a = a + v.level_no , 0
                            )-this.state.stankomData?.reduce(
                                (a, v) => a = a + v.stancom_competence_level , 0
                            ))
                            }</th>
                        </tr>
                        <tr>
                            <td colSpan="9"></td>
                        </tr>
                        <tr>
                            <td colSpan="2"></td>    
                            <td colSpan="6" style={{background:"#808e95",textAlign:"right"}} className="text-white" align="right">JPM</td>    
                            <td style={{background:"#808e95"}} className="text-white text-center">{this.state.acData.assessment_jpm} %</td>    
                        </tr>
                    </tfoot>
                </table> 
                <br />
                <table className="table table-bordered table-striped">
                    {/* <tbody> */}
                        <tr>
                            <td className="bg-danger">&nbsp;</td>
                            <td>&nbsp;Hasil Individu Kurang dari Standar Kompetensi</td>
                        </tr>
                        <tr>
                            <td className="bg-success">&nbsp;</td>
                            <td>&nbsp;Hasil Individu Memenuhi Standar Kompetensi</td>
                        </tr>
                        <tr>
                            <td className="bg-info">&nbsp;</td>
                            <td>&nbsp;Hasil Individu Melebihi Standar Kompetensi</td>
                        </tr>
                    {/* </tbody> */}
                </table>                         
            </Fragment>
        )
    }
}

//export default IndexView
export default Kompt;